__webpack_require__.p = "/pwa-stampimg/";